import React from "react";
import http from '../modules/api';
import FileDownload from 'js-file-download';
import * as CookieUtil from '../modules/utils/CookieUtil';
import icn_download_white from '../../resources/img/download_white.svg'
import icn_download from '../../resources/img/download.svg'
import $ from 'jquery';

var this_component;

/**
 * 이미지 다운로드 요청 생성
 * @param {*} file_name 
 * @param {*} req_list : [{
          event_seq : event_seq
        , platform_type : platform_type
        , banner_width : banner_width
        , banner_height : banner_height
        , org_banner_width : org_banner_width
        , org_banner_height : org_banner_height 
        , mirror_type : mirror_type
    }]
*/
export function fn_contentDownload(file_name, req_list, onDone, is_instagram) {
    // 다운로드 준비상태 : 진행중
    // this.setState({[download_type]:false});
    CookieUtil.setCookie("downloadmanager_active", "T");
    $('#btn_download_manager').css('visibility', 'visible');
    //this.fn_selectUserDownloadList();

    const config = {
        headers: {
            'content-type': 'application/json;'
        },
    }
    http.post("/rest/shop/cafe24/event/capture_v2",
                {
                     req_list : req_list,
                     file_name : file_name,
                     is_instagram : is_instagram ? is_instagram : "N"
                }, 
                config )
    .then(res => {
        if (res.data.code == "200") {
            let req_download_list = [...this_component.state.req_download_list];
            let req_download_map = {
                req_seq: res.data.req_seq,
                multi_image_yn: res.data.multi_image_yn,
                is_done: res.data.is_done,
                file_name: res.data.file_name,
                //content_code: file_name,
            }
            req_download_list.unshift(req_download_map);
            this_component.setState({
                req_download_list: req_download_list
            });
            //this_component.fn_selectUserDownloadList();
            // 캡처요청 상태 조회
            let limit_count = 0;
            this_component.fn_captureStateChecker(res.data.req_seq, res.data.multi_image_yn, file_name, limit_count, onDone);
            // 다운로드 내역 열기
            this_component.onClickDownloadManagerOn();
        } else {
            if (onDone) onDone();
            alert(res.data.code + "\n" + res.data.msg);
        }
    })
    .catch(error => {
        if (onDone) onDone();
        console.log (error);
        alert("배너 다운로드 요청 실패\n고객센터 : 1599-3518");
        // 다운로드 준비상태 : 완료
        // this.setState({[download_type]:true});
    });
}

class CommonDownloadManager extends React.Component {
    /**
     * {  
     *    content_code: "20230516/0af4cfdc-f384-11ed-9a05-02a0e1f870bc-o.png"
     *   ,is_done: "D"
     *   ,mod_date: "2023-05-16 09:53:23"
     *   ,multi_image_yn: "N"
     *   ,reg_date: "2023-05-16 09:53:15"
     *   ,req_seq: 1494
     *   ,user_seq: 104
     * }
     */
	state = {
        downloadmanager_active: "F",
		req_download_list: [],
	}

	// 사용자 다운로드 요청 리스트 조회
	async fn_selectUserDownloadList() {
		const config = {
			headers: {
				'content-type': 'application/json;'
			},
		}
		await http
		.post("/rest/shop/cafe24/content/downloadList", {}, config )
		.then((res) => {
			if (res.data != null) {
				//console.log(res.data.list);
				this.setState({
					req_download_list : res.data.list
				}, () => {
                    const { req_download_list } = this.state;
                    if (req_download_list != null) {
                        //$('#download_manager').css('visibility', 'visible');
                        for (let i = 0; i < req_download_list.length; i++) {
                            if (req_download_list[i].is_done == "P") {
                                //console.log(req_download_list[i]);
                                let limit_count = 0;
                                this.fn_captureStateChecker(
                                    req_download_list[i].req_seq, 
                                    req_download_list[i].multi_image_yn, 
                                    req_download_list[i].file_name,
                                    limit_count
                                );
                            }
                        }
                    }
                })
			} else {
                CookieUtil.setCookie("downloadmanager_active", "F");
                $('#btn_download_manager').css('visibility', 'hidden');
            }
		});
	}

	// 캡처요청 상태 조회
    fn_captureStateChecker(req_seq, multi_image_yn, file_name, limit_count, onDone) {
        limit_count = limit_count + 1
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
        }
		http.post("/rest/shop/cafe24/content/stateChecker", { req_seq : req_seq, multi_image_yn : multi_image_yn }, config )
        .then(res => {
            if (res.data.is_done == "D") {
                //console.log("[0] " + limit_count +  "/ " + res.data.content_code);
                this.fn_s3FileDownload(req_seq, multi_image_yn, res.data.content_code, file_name, onDone);
            } else {
                if (limit_count < 100) {
                    new Promise( ( resolve, reject ) => {setTimeout( resolve, 1000 ); })
                    .then( () => {
                        //console.log("[1] : " + limit_count + " : 호출 재시도 ");
                        // 캡처요청 상태 조회 재시도
                        this.fn_captureStateChecker(req_seq, multi_image_yn, file_name, limit_count, onDone);
                    });
                } else {
                    //alert("이미지 캡처 상태조회 실패\n고객센터 : 1599-3518");
                    // 다운로드 준비상태 : 완료
                    //this.setState({[download_type]:true});
                    let req_download_list = [...this.state.req_download_list];
                    let idx = req_download_list.findIndex((req_map) => req_map.req_seq+"_"+req_map.multi_image_yn == req_seq+"_"+multi_image_yn)
                    req_download_list[idx].is_done = "F";
                    this.setState({
                        req_download_list: req_download_list
                    });

                    if (onDone) onDone();
                }
            }
        })
        .catch(error => {
            alert("이미지 캡처 상태조회 오류\n고객센터 : 1599-3518");
            // 다운로드 준비상태 : 완료
            //this.setState({[download_type]:true});
            let req_download_list = [...this.state.req_download_list];
            let idx = req_download_list.findIndex((req_map) => req_map.req_seq+"_"+req_map.multi_image_yn == req_seq+"_"+multi_image_yn)
            req_download_list[idx].is_done = "F";
            this.setState({
                req_download_list: req_download_list
            });
            console.log("#### fn_captureStateChecker [ERROR] start ####");
            console.log(error);
            console.log("#### fn_captureStateChecker [ERROR] end ####");
        });
    }

    // s3 파일 다운로드
    fn_s3FileDownload(req_seq, multi_image_yn, content_code, file_name, onDone) {
        // 파일 확장자 추출
        let file_type = content_code.substring(content_code.lastIndexOf(".")+1, content_code.length);
        const config = {
            headers: {
                'content-type': 'application/json;'
            },
            responseType: 'arraybuffer'
        }
        http.post("/rest/shop/cafe24/content/download",
            {
                "req_seq" : req_seq, 
                "multi_image_yn" : multi_image_yn,
                "content_code" : content_code
            },
            config
        )
        .then(res => {
            if (res.data != null) {
                if(file_name){
                    // 파일명으로 사용 불가능한 특수문자 제거
                    file_name = file_name.replace(/[`~!@#$%^&*|\\\'\";:\/?]/gi, "");
                } else{
                    // 상품명(제목) 미입력시 '제목없음'로 다운로드
                    file_name = '제목없음';
                }
                file_name = file_name + '.'+file_type;
                var blob = new Blob([res.data], { type: file_type });
                FileDownload(blob, decodeURI(file_name));
            } else {
                alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
            }
            // 다운로드 준비상태 : 완료
            //this.setState({[download_type]:true});
            let req_download_list = [...this.state.req_download_list];
            let idx = req_download_list.findIndex((req_map) => req_map.req_seq+"_"+req_map.multi_image_yn == req_seq+"_"+multi_image_yn)
            req_download_list[idx].content_code = content_code;
            req_download_list[idx].is_done = "D";
            this.setState({
                req_download_list: req_download_list
            });

            if (onDone) onDone();
        })
        .catch(error => {
            alert("s3 이미지 다운로드 요청 실패\n고객센터 : 1599-3518");
            // 다운로드 준비상태 : 완료
            //this.setState({[download_type]:true});
            let req_download_list = [...this.state.req_download_list];
            let idx = req_download_list.findIndex((req_map) => req_map.req_seq+"_"+req_map.multi_image_yn == req_seq+"_"+multi_image_yn)
            req_download_list[idx].is_done = "F";
            this.setState({
                req_download_list: req_download_list
            });

            if (onDone) onDone();
        });
    }

    onClickBannerDownload = (idx, downloadmap) => {
        let req_download_list = [...this.state.req_download_list];
        req_download_list[idx].is_done = "";
        this.setState({
            req_download_list: req_download_list
        });
        this.fn_s3FileDownload(downloadmap.req_seq, downloadmap.multi_image_yn, downloadmap.content_code, downloadmap.file_name);
    }

    onClickDownloadManagerOn = (e, state) => {
		$("#download_manager").show();
		$('#download_manager').css('visibility', 'visible');
	}

    onClickDownloadManagerHide = (e, state) => {
		$("#download_manager").hide();
		$('#download_manager').css('visibility', 'hidden');
	}

    onClickDownloadManagerOff = (e, state) => {
        CookieUtil.setCookie("downloadmanager_active", "F");
        $('#btn_download_manager').css('visibility', 'hidden');
        this.onClickDownloadManagerHide();
	}
	
	componentDidMount() {
        this_component = this;
        let downloadmanager_active = CookieUtil.getCookie("downloadmanager_active");
        if (downloadmanager_active == "T") {
            $('#btn_download_manager').css('visibility', 'visible');
            this.fn_selectUserDownloadList();
            //this.onClickDownloadManagerOn();
        }
	}

	render () {
		return (
			<>
                {/* 다운로드 매니저 팝업 */}
                <div id="download_manager" className="download_manager"
                     //className="mirror_banner_modal_v2" 
                     style={{
                           position: "fixed"
                         , bottom: "0px"
                         , right: "0px"
                         , background: "#FFFFFF"
                         , padding: "15px 20px"
                         , boxShadow: "0px 4px 10px "
                         , zIndex: "10000"
                         , margin: "0 15px 75px 0"
                         , borderRadius: "13px"
                         , visibility: "hidden"
                    }}>
                    <div className="mirror_banner_v2_inner_area">
                        <div className="mirror_banner_v2_title">
                            <div style={{flex: 100}}>
                                다운로드
                            </div>
                            <div className="hovertext" data-hover="내리기" style={{borderTopWidth:"2px", marginRight:"15px", padding:"5px 0"}}>
                                <div className="btn_minus" style={{position:"relative"}} onClick={e => this.onClickDownloadManagerHide(e)}></div>
                            </div>
                            <div className="btn_close_v2 cursor-pointer hovertext" data-hover="닫기" onClick={e => this.onClickDownloadManagerOff(e)}></div>
                        </div>
                        <div className="mirror_banner_v2_body"
                            style={{
                                maxHeight:"175px", minHeight:"34px", overflowY: 'auto', paddingTop:"5px"
                            }}>
                            {/* 내용 */}
                            <table style={{minWidth:"250px"}}>
                                {
                                    (this.state.req_download_list != null)
                                    ?
                                        // <>
                                        //     { JSON.stringify(this.state.req_download_list) }
                                        // </>
                                        this.state.req_download_list.map((downloadmap, idx) => (
                                            <tr style={{height:"34px"}}>
                                                <td id={downloadmap.req_seq + "_" + downloadmap.multi_image_yn} style={{width:"200px", verticalAlign: "middle"}}>
                                                    <p style={{textAlign:"left", fontSize:"10px", margin: "0px 15px"}}>{downloadmap.file_name}</p>
                                                </td>
                                                {/* <td style={{width:"70px"}}>
                                                    <p style={{fontSize:"10px"}}>{downloadmap.is_done}</p>
                                                </td> */}
                                                <td style={{verticalAlign: "middle", textAlign:"-webkit-center"}}>
                                                    <div className="cursor-pointer" style={{}}>
                                                        {
                                                            downloadmap.is_done == "D"
                                                            ? 
                                                            <img src={icn_download} style={{alignSelf:"center"}} onClick={e => this.onClickBannerDownload(idx, downloadmap)}/>
                                                            : downloadmap.is_done == "F" ?
                                                            <span className="i_notice_banner hovertext" style={{color: "#ff085e"}} data-hover="[요청 실패] 잠시 후 다시 시도해 주세요.">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                                    fill="currentColor" className="bi bi-info-circle-fill" viewBox="0 0 16 16">
                                                                    <path
                                                                        d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                                                                </svg>
                                                            </span>
                                                            :
                                                            <div className="list_loading" style={{alignSelf: "center"}}>
                                                                <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
                                                            </div>
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    :
                                    <tr>
                                        <td colSpan={2}>{'다운로드 요청 내역이 없습니다.'}</td>
                                    </tr>
                                }
                            </table>
                        </div>
                        <div className="flexBox width-100" style={{height:"15px"}}></div>
                        <font style={{margin:"auto", color:"#bfc4d6", fontSize:"10px", lineHeight:"10px"}}>(최근 30일간 다운로드 요청 리스트 입니다.)</font>
                    </div>
                </div>
                {/* 다운로드 매니저 버튼 */}
                <div id="btn_download_manager" className="btn_download_manager"
                    style={{
                        display: "flex",
		                justifyContent: "center",
		                position: "fixed",
		                right: "2%",
		                bottom: "65px",
	                    zIndex: "9997",
	                    cursor: "pointer",
                        visibility: "hidden"
                    }}
                    onClick={e => this.onClickDownloadManagerOn()}
                >
                    <svg width="89" height="90" viewBox="0 0 89 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_7578_107363)">
                            <rect x="7" y="7" width="69" height="70" rx="34.5" fill="#00E2E6" shape-rendering="crispEdges"/>
                            <path d="M37.0281 27.8469C36.8876 27.7051 36.8092 27.5134 36.8101 27.3139C36.811 27.1143 36.8911 26.9233 37.0328 26.7828C37.1745 26.6423 37.3663 26.5639 37.5658 26.5648C37.7654 26.5657 37.9564 26.6458 38.0969 26.7875L40.75 29.4406V20.75C40.75 20.5511 40.829 20.3603 40.9697 20.2197C41.1103 20.079 41.3011 20 41.5 20C41.6989 20 41.8897 20.079 42.0303 20.2197C42.171 20.3603 42.25 20.5511 42.25 20.75V29.4406L44.9031 26.7875C44.9727 26.7173 45.0554 26.6615 45.1465 26.6233C45.2376 26.5851 45.3354 26.5652 45.4342 26.5648C45.533 26.5643 45.6309 26.5834 45.7224 26.6208C45.8138 26.6582 45.897 26.7133 45.9672 26.7828C46.0374 26.8524 46.0932 26.9351 46.1314 27.0262C46.1696 27.1173 46.1895 27.2151 46.1899 27.3139C46.1903 27.4127 46.1713 27.5106 46.1339 27.6021C46.0965 27.6935 46.0414 27.7767 45.9719 27.8469L42.0344 31.7844C41.891 31.923 41.6994 32.0005 41.5 32.0005C41.3006 32.0005 41.109 31.923 40.9656 31.7844L37.0281 27.8469ZM49.75 30.5C49.5511 30.5 49.3603 30.579 49.2197 30.7197C49.079 30.8603 49 31.0511 49 31.25V36.5H34V31.25C34 31.0511 33.921 30.8603 33.7803 30.7197C33.6397 30.579 33.4489 30.5 33.25 30.5C33.0511 30.5 32.8603 30.579 32.7197 30.7197C32.579 30.8603 32.5 31.0511 32.5 31.25V36.5C32.5 36.8978 32.658 37.2794 32.9393 37.5607C33.2206 37.842 33.6022 38 34 38H49C49.3978 38 49.7794 37.842 50.0607 37.5607C50.342 37.2794 50.5 36.8978 50.5 36.5V31.25C50.5 31.0511 50.421 30.8603 50.2803 30.7197C50.1397 30.579 49.9489 30.5 49.75 30.5Z" fill="#333333"/>
                            <path d="M28.5327 43.903H29.4567V53.869H28.5327V43.903ZM29.2367 47.83H31.0847V48.6H29.2367V47.83ZM22.2297 50.624H23.0107C24.8477 50.624 26.1347 50.558 27.6197 50.283L27.7187 51.053C26.1897 51.339 24.8807 51.394 23.0107 51.394H22.2297V50.624ZM22.2297 44.871H26.8497V45.619H23.1317V50.965H22.2297V44.871ZM31.9199 48.952H40.9399V49.7H31.9199V48.952ZM36.0339 49.425H36.9579V51.713H36.0339V49.425ZM33.0639 52.879H39.9389V53.638H33.0639V52.879ZM33.0639 50.734H33.9769V53.088H33.0639V50.734ZM36.4189 44.156C38.5199 44.156 39.9059 44.926 39.9059 46.158C39.9059 47.39 38.5199 48.16 36.4189 48.16C34.3069 48.16 32.9319 47.39 32.9319 46.158C32.9319 44.926 34.3069 44.156 36.4189 44.156ZM36.4189 44.904C34.9009 44.904 33.8999 45.388 33.8999 46.158C33.8999 46.939 34.9009 47.412 36.4189 47.412C37.9369 47.412 38.9379 46.939 38.9379 46.158C38.9379 45.388 37.9369 44.904 36.4189 44.904ZM42.05 51.878H51.059V52.637H42.05V51.878ZM46.076 49.744H46.989V52.197H46.076V49.744ZM43.139 44.651H49.948V47.665H44.074V49.656H43.172V46.928H49.046V45.388H43.139V44.651ZM43.172 49.271H50.179V50.019H43.172V49.271ZM53.3021 48.677H60.1331V49.425H53.3021V48.677ZM52.1691 51.757H61.1781V52.516H52.1691V51.757ZM53.3021 44.827H60.0341V45.586H54.2151V49.007H53.3021V44.827ZM34.4393 54.914H35.3193V64.858H34.4393V54.914ZM32.8663 58.852H34.7693V59.6H32.8663V58.852ZM32.2393 55.123H33.1083V64.363H32.2393V55.123ZM27.2233 56.058H31.0183V62.196H27.2233V56.058ZM30.1603 56.784H28.0813V61.47H30.1603V56.784ZM44.2174 54.914H45.1304V64.858H44.2174V54.914ZM37.6174 55.882H38.5194V62.042H37.6174V55.882ZM37.6174 61.503H38.4314C39.9384 61.503 41.5114 61.393 43.1944 61.041L43.3044 61.822C41.5774 62.174 40.0044 62.295 38.4314 62.295H37.6174V61.503ZM54.3806 54.903H55.2826V64.869H54.3806V54.903ZM52.2356 58.533H54.6446V59.281H52.2356V58.533ZM49.6286 56.333H50.3656V57.818C50.3656 59.963 49.1336 62.086 47.5606 62.9L47.0216 62.174C48.4516 61.47 49.6286 59.589 49.6286 57.818V56.333ZM49.8156 56.333H50.5416V57.818C50.5416 59.479 51.6966 61.294 53.1376 61.976L52.5986 62.691C51.0256 61.91 49.8156 59.864 49.8156 57.818V56.333ZM47.3846 55.926H52.7966V56.685H47.3846V55.926Z" fill="#3A3A3A"/>
                        </g>
                        <defs>
                            <filter id="filter0_d_7578_107363" x="0" y="0" width="89" height="90" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                <feOffset dx="3" dy="3"/>
                                <feGaussianBlur stdDeviation="5"/>
                                <feComposite in2="hardAlpha" operator="out"/>
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7578_107363"/>
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7578_107363" result="shape"/>
                            </filter>
                        </defs>
                    </svg>
                </div>

                {/* 팝업창 배경 */}
                {/* <div id="modalBack" style={{top: "0", height:"130%"}}></div> */}
				{/* <div id="download_manager" style={{position:'absolute', bottom:"10px", right:"10px", backgroundColor:"aqua"}}>
					<div
						style={{
							width: '600px',
							minWidth: '450px',
							height: '500px',
							maxHeight: '70vh',
							overflowY: 'auto',
						}}
					>
						
						{/* <div dangerouslySetInnerHTML={{__html: this.props.content}}></div> */}
						{/* 버튼영역 */}
						{/* <div
							className="sample_banner_btn_area"
							style={{
								margin: '40px auto 20px',
								width: '80%',
								maxWidth: 'calc(600px + 16%)',
								height: '60px',
								display: 'flex',
							}}
						>
						</div>
					</div>
				</div> */}
			</>
		);
	}
}

export default CommonDownloadManager;